module.exports = __webpack_public_path__ + "img/icn_check_hv_chakui.557d3b10.png";